<template>
  <div
    class="color-bg-fff border-radius-5 padding-x-10 padding-top-20 padding-bottom-10 margin-bottom-20"
  >
    <div class="flex-start">
      <img
        style="width: 60px; height: 60px"
        class="margin-x-20 margin-bottom-10"
        src="./static/icon_user_headimg.png"
        alt=""
      />
      <el-descriptions column="4">
        <el-descriptions-item label="用户编号">{{ baseUserInfoVo.userId }}</el-descriptions-item>
        <el-descriptions-item label="注册手机号">
          {{ baseUserInfoVo.mobilePhone }}
        </el-descriptions-item>
        <el-descriptions-item label="uuid">{{ baseUserInfoVo.uuid }}</el-descriptions-item>
        <el-descriptions-item label="注册时间">
          {{ baseUserInfoVo.createTime }}
        </el-descriptions-item>
        <el-descriptions-item label="用户身份">{{ userIdentity }}</el-descriptions-item>
        <el-descriptions-item label="用户来源">
          {{ baseUserInfoVo.userSource }}
        </el-descriptions-item>
        <el-descriptions-item label="性别">{{ userGender }}</el-descriptions-item>
        <el-descriptions-item label="生日">
          {{ baseUserInfoVo.birthday }}
        </el-descriptions-item>
        <el-descriptions-item label="年龄">
          {{ baseUserInfoVo.age }}
        </el-descriptions-item>
        <el-descriptions-item label="地区">
          {{ baseUserInfoVo.cityName }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="label-info">
      <div class="label-info-title">
        <span>标签：</span>
        <el-button v-has-permi="['user_edit']" type="text" @click="handleLabel(baseUserInfoVo)"
          >编辑</el-button
        >
      </div>
      <div class="label-info-content">
        <el-tag
          class="label-tag"
          v-for="tag in baseUserInfoVo.tags"
          :key="tag.id"
          type="info"
          effect="plain"
        >
          {{ tag.tagName }}
        </el-tag>
      </div>
    </div>
  </div>
</template>

<script >
import { inject, computed } from '@vue/composition-api';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const genderOptions = [{
    label: '未知',
    value: 0
  }, {
    label: '男',
    value: 1
  }, {
    label: '女',
    value: 2
  }];

  // 用户信息
  const userInfo = inject('userInfo');
  // 打标
  const handleLabel = inject('handleLabel');

  // 基础信息
  const baseUserInfoVo = computed(() => {
    return userInfo && userInfo.value && userInfo.value.baseUserInfoVo ? userInfo.value.baseUserInfoVo : {};
  });

  // 用户身份
  const userIdentity = computed(() => {
    if (baseUserInfoVo.value && baseUserInfoVo.value.userIdentity && Array.isArray(baseUserInfoVo.value.userIdentity) && baseUserInfoVo.value.userIdentity.length) {
      const result = baseUserInfoVo.value.userIdentity.join().replace(/,/g, '/');
      return result;
    }
    return '';
  });

  // 用户性别
  const userGender = computed(() => {
    if (baseUserInfoVo.value && baseUserInfoVo.value.gender) {
      const obj = genderOptions.find(item => parseInt(item.value) === parseInt(baseUserInfoVo.value.gender));
      if (obj) {
        return obj.label;
      }
    }
    return '';
  });
  return {
    handleLabel,
    baseUserInfoVo,
    userIdentity,
    userGender
  };
};
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .label-info {
    padding-left: 20px;
    .label-tag {
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }
  ::v-deep .el-tag--plain.el-tag--info {
    border-color: #909399;
    color: #606266;
  }
</style>
